export const TRAILER = 'TRAILER';
